import React from "react";

function BS4_Popover() {
  return (
    <div>
      <h1>BS4_Popover Component</h1>
      <p>This is the BS4_Popover tutorial page content.</p>
    </div>
  );
}

export default BS4_Popover;
